import { render, staticRenderFns } from "./InfoInvestigationForm.vue?vue&type=template&id=64bdc378&scoped=true"
import script from "./InfoInvestigationForm.vue?vue&type=script&lang=js"
export * from "./InfoInvestigationForm.vue?vue&type=script&lang=js"
import style0 from "./InfoInvestigationForm.vue?vue&type=style&index=0&id=64bdc378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bdc378",
  null
  
)

export default component.exports